/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';

import {
    IPReputationTypeMatchConfigItem,
} from 'ajs/modules/match/factories/ip-reputation-type-match.config-item.factory';

import * as globalL10n from 'global-l10n';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Readonly match component for IPReputationTypeMatch.
 * @author Rohit Gaikwad
 */
@Component({
    selector: 'ip-reputation-type-match-readonly',
    templateUrl: './ip-reputation-type-match-readonly.component.html',
})
export class IpReputationTypeMatchReadonlyComponent {
    /**
     * IP Reputation Type message item instance.
     */
    @Input()
    public editable: IPReputationTypeMatchConfigItem;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {}

    /**
     * Returns appropriate label for selected reputation type.
     */
    public reputationTypeLabel(reputationType: any): string {
        return this.schemaService.getEnumValueLabel(
            'IPReputationType',
            reputationType,
        );
    }

    /**
     * Convenience method to get text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_operation,
        );
    }

    /**
     * Used in *ngFor.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
